/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";

import { InputText as InputTextPR } from "primereact/inputtext";

import { cssFormElements } from "../css";
import { FormErrorMessage } from "validation/form-error-message";

const InputGroup = ({ required, formik, size, ...data }) => {
  const theme = useTheme();

  const elWidth = `${size || "100"}%`;

  const getLabel = data?.label && (
    <label>
      {data.label}
      {required && <span>*</span>}
    </label>
  );

  const elProps = {
    ...Object.keys(data).reduce((acc, key) => {
      if (key !== "data") {
        acc[key] = data[key];
      }
      return acc;
    }, {}),
  };

  const getElement = <InputTextPR {...elProps} />;

  return (
    <div className="p-input" css={cssFormElements(theme, elWidth).inputGroup}>
      {getLabel}

      <div className="p-inputgroup">
        <span className="p-inputgroup-addon">http(s)://</span>
        {getElement}
      </div>
      {required && <FormErrorMessage name="name" formik={formik} />}
    </div>
  );
};

export default InputGroup;
